import { Card } from "react-bootstrap";
import i18n from "../i18n"
import {Link} from "react-router-dom";
import useDocument from '../hooks/useDocument.hooks'
import {Trans} from 'react-i18next';

function ErrorPage() {

    const { t } = i18n;

    useDocument({title: t('_page_title.error')})

    return (
        <>
            <Card.Body>
                <Card.Title className="text-start"><h1>{t('error')}</h1></Card.Title>
                <Card.Text className="text-start">
                    <Trans i18nKey="_system_error" />
                    <br />
                </Card.Text>
                <Card.Footer className="d-flex justify-content-end align-items-center">
                    <div className='text-end help-link mx-2'>
                        <Link to="/auth/login" className='text-decoration-none' reloadDocument>
                        {t('verify_email_advice.back_home')}
                        </Link>
                    </div>
                </Card.Footer>
            </Card.Body>
        </>
    )
}

export default ErrorPage